import { getCategoryForType } from './eventCategories';

// Real photos come from the source site (image_url). Only 47% of events have
// one, so the category stock photo is the fallback rather than the default.
export function getEventImageUrl(event) {
  const scraped = String(event?.image_url || '').trim();
  if (scraped.startsWith('http')) {
    return scraped;
  }
  return getFallbackImageUrl(event?.event_type);
}

export function getFallbackImageUrl(eventType) {
  return `/pics/${getCategoryForType(eventType).image}.jpg`;
}

export function hasRealImage(event) {
  return String(event?.image_url || '').trim().startsWith('http');
}
